import { render, staticRenderFns } from "./PageReferenceWidget.vue?vue&type=template&id=1e3bd8c0&scoped=true"
import script from "./PageReferenceWidget.vue?vue&type=script&lang=js"
export * from "./PageReferenceWidget.vue?vue&type=script&lang=js"
import style0 from "./PageReferenceWidget.vue?vue&type=style&index=0&id=1e3bd8c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3bd8c0",
  null
  
)

export default component.exports